// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f7b13950","455":"d939faa1"}[chunkId] + ".chunk.js";
};